import { memo, useRef, useMemo, useEffect, useState, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BzTab, BzTabs, BzButton, BzMasterAgGrid, BzChip } from "../../../components";
import {
    ORDERS_GRID_REF, getMktSegIdFromApiExchangeName, displayZeroStateForGrid,
    isGuestUser, convertScripResponseWatchlistGrid,
    handleScripUnsubScriptionOnUnMount,
    convertColumnsDatatoGridColumns,
    convertTOVariable,
    deepClone,
    gridDateFilter
} from "../../../utils/global_functions";
import {
    ALL_ORDERS_STATUS, TL_INDEX, ORDERS_TABKEY, ORDERS_LIMIT_IN_API, ORDERBOOK_API_ORDER_STATUS,
    WATCHLIST_GRID_INDEX,
    ORDER_TYPES,
    MARKET_SEGMENT_ID,
    GRID_ROW_SELECTION_TYPE,
    MANAGE_COLUMNS_VIEW_TYPES
} from '../../../utils/global_variables';
import { sendBestFiveRequest, sendTouchlineRequest } from "../../../apis/web_socket";
import { useDebounce, useSingleKey, useUnload, useWFHMessages } from "../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { handleModal, handleModalData } from "../../../redux/actions/modals";
import StatusChip from "../StatusChip";
import SipGridPopover from "./SipGridPopover";
import { getAllSipOrders, getScripOrderInfo, setCurrentPage } from "../../../redux/actions/orders";
import { getWfhTouchlineLastTick } from "../../../redux/actions/wfh";
import { uniqBy } from "lodash";
import moment from "moment";
import { _getSIPOrderDisplayStatus, _getScripsInfo } from "../../../controllers";
import useAnalyticsEventTracker from "../../../hooks/useAnalyticsEventTracker";
import GridHeaderSearch from "../../GridHeaderSearch";
import { setScripOverviewData } from "../../../redux/actions/marketOverview";
import ZeroStates from "../../ZeroStates";
import { LoginLoader } from "../../Login";
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
let bIsApiFiring = false;
// Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
const isHistoryAllowed = true;

const Sip = ({ getRowId, ordersTabKey, ordersSingleScripKey, setOrdersTabKey, setOrdersSingleScripKey, arrCompletedOrders, arrOpenOrders, handleDelete, activeFilters, tempOrders, setIsShowOrderFilterModelsModal, isMasterDetail, gridDetailCellRenderer, setOrderEntryTab, onCancelOrder, isButtonDisabled, onRowSelected, isRowSelectable, onTabChange, ...props }) => {
    const dispatch = useDispatch();

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const getSipOrder = useSelector(state => state.orders.getSipOrder);
    const arrAllSipOrders = useSelector(state => state.orders.arrAllSipOrders);
    const arrOpenSipOrders = useSelector(state => state.orders.arrOpenSipOrders);
    const arrCompletedSipOrders = useSelector(state => state.orders.arrCompletedSipOrders);
    const nCurrentPage = useSelector(state => state.orders.nCurrentPage);
    const objEquitySIPMetaData = useSelector(state => state.orders.objEquitySIPMetaData);
    const objLoginSession = useSelector(state => state?.auth?.objLoginSession);



    const arrSipEquityOrderColumnDefs = useSelector(state => state?.orders?.arrSipEquityOrderColumnDefs);
    // Azeem K : 07-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const holdingsScrips = useSelector(state => state.holdings?.holdingsScrips);
    // Azeem K : 07-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End


    const [arrSipOrdersGridRowData, setArrSipOrdersGridRowData] = useState(arrAllSipOrders);
    const searchedText = useRef('');
    const [filteredData, setFilteredData] = useState([]);

    const userColumnProfiles = useSelector(state => state?.watchList?.userColumnProfiles);
    const objViewWiseColumnProfiles = useSelector(state => state.watchList.objViewWiseColumnProfiles);
    const SIPTenantColumnProfiles = useMemo(() => {
        const SIPColumDetails = deepClone(userColumnProfiles)?.find(eachProfile => eachProfile?.sViewType?.toLowerCase() === MANAGE_COLUMNS_VIEW_TYPES?.ORDER_EQUITY_SIP_VIEW_TYPE?.toLowerCase() && eachProfile?.bIsDefault);
        let settings = {};
        if (SIPColumDetails) {
            const updatedColumnDetails = deepClone(SIPColumDetails?.columnDetails)?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            return convertColumnsDatatoGridColumns(updatedColumnDetails, MANAGE_COLUMNS_VIEW_TYPES.ORDER_EQUITY_SIP_VIEW_TYPE);
        } else {
            const updatedColumnDetails = objViewWiseColumnProfiles[MANAGE_COLUMNS_VIEW_TYPES.ORDER_EQUITY_SIP_VIEW_TYPE]?.map((eachProfile) => {
                let originalField;
                if (typeof eachProfile.sSettings === 'string') {
                    settings = JSON?.parse(eachProfile?.sSettings);
                    originalField = deepClone(settings?.field);
                } else {
                    settings = { ...eachProfile?.sSettings };
                    originalField = deepClone(settings?.field);
                }
                eachProfile.sSettings = { ...settings, extraField: originalField, field: typeof settings?.field === "number" ? settings?.field.toString() : convertTOVariable(settings?.field) };
                return eachProfile;
            });
            const arrdDefaultColumns = updatedColumnDetails?.filter(eachColumn => eachColumn?.sSettings?.bIsFixed === "true" || eachColumn?.sSettings?.bIsDefault === "true");
            return convertColumnsDatatoGridColumns(arrdDefaultColumns, MANAGE_COLUMNS_VIEW_TYPES.ORDER_EQUITY_SIP_VIEW_TYPE);
        }
    }, [userColumnProfiles, objViewWiseColumnProfiles]);

    useEffect(() => {
        const arrUniqScrips = uniqBy(arrSipOrdersGridRowData, 'segment_id');
        return () => {
            let arrScrips = arrUniqScrips?.map((each) => ({
                exchangeId: getMktSegIdFromApiExchangeName(each.exchangeSegment),
                token: each.scrip_token,
                isSubscribe: false
            }));
            sendTouchlineRequest(arrScrips);
        };
    }, [arrSipOrdersGridRowData]);

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const handleSipGrid = useCallback((arrTouchLineData) => {

        const arrFilteredData = arrSipOrdersGridRowData?.filter((each) => {
            return each?.segment_id === arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN];
        });
        if (arrFilteredData?.length > 0) {

            const arrUpdatedOrders = arrFilteredData?.map((each, i) => {
                return {
                    ...each,
                    expandCell: each?.expandCell,
                    symbol: each?.symbol,
                    assest_type: each?.assest_type,
                    bDetail: each?.bDetail,
                    bModify: each?.bModify,
                    bStop: each?.bStop,
                    bView: each?.bView,
                    caa_remark: each?.caa_remark,
                    cap_price: each?.cap_price,
                    created_by: each?.created_by,
                    created_date: each?.created_date,
                    display_transaction_type: each?.display_transaction_type,
                    exchange: each?.exchange,
                    executed_installments: each?.executed_installments,
                    frequency_details: each?.frequency_details,
                    frequency_start_date: each?.frequency_start_date,
                    frequency_type: each?.frequency_type,
                    installment_date: each?.installment_date,
                    invested_qty_or_val: each?.invested_qty_or_val,
                    investment_type: each?.investment_type,
                    investment_value: each?.investment_value,
                    modified_by: each?.modified_by,
                    no_of_installments: each?.no_of_installments,
                    scrip_token: each?.scrip_token,
                    series: each?.series,
                    status: each?.status,
                    traded_quantity: each?.traded_quantity,
                    transaction_type: each?.transaction_type,
                    updated_status: each?.updated_status,
                    executed_and_numberof_installment: each?.executed_and_numberof_installment,
                    id: each?.id,
                    ltp: arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE],
                    frequency_monthly_option: each?.frequency_monthly_option,
                    frequency_specific_date: each?.frequency_specific_date,
                    frequency_days: each?.frequency_days, // BT-107418 - Vinit R - 28/03/2024 Breeze SIP order Book
                    segment_id: each?.segment_id,
                    orderHistory: each?.orderHistory,
                    time: each?.time,
                    cmv: each.traded_quantity > 0 && each.total_transaction_amount ? (parseFloat(arrTouchLineData[TL_INDEX.LAST_TRADE_PRICE]) * parseFloat(each.traded_quantity)).toFixed(2) : 0.00
                };

            }

            );
            ORDERS_GRID_REF?.current?.api?.applyTransaction({
                update: [...arrUpdatedOrders]
            });
        }

    }, [arrSipOrdersGridRowData]);


    const [objScripsRequest, setObjScripsRequest] = useState({});
    const handleVisibleRows = useCallback(() => {
        setObjScripsRequest(prevState => {
            let objpreviosScripsCopy = prevState;
            let arrWithKeys = [];
            let subscribeScrips = []; // This array is a non repeated subscrips for subscription
            let unSubScribeScrips = []; // this array is scrips of unsubscription]
            const arrVisibleRows = ORDERS_GRID_REF?.current?.api?.getRenderedNodes().map(item => {
                let id = getMktSegIdFromApiExchangeName(item?.data?.exchangeSegment) + '_' + item?.data?.scrip_token;
                arrWithKeys?.push(id);
                if (!objpreviosScripsCopy[id]) {
                    objpreviosScripsCopy[id] = true;
                    subscribeScrips?.push({ exchangeId: getMktSegIdFromApiExchangeName(item?.data?.exchangeSegment), token: item?.data?.scrip_token, isSubscribe: true });

                }
                return { exchangeId: getMktSegIdFromApiExchangeName(item?.data?.exchangeSegment), token: item?.data?.scrip_token, isSubscribe: true };
            });
            Object?.keys(objpreviosScripsCopy)?.forEach(key => {
                if (!arrWithKeys.includes(key)) {
                    let obj = {
                        exchangeId: Number(key?.split('_')[0]),
                        token: Number(key?.split('_')[1]),
                        isSubscribe: false
                    };
                    unSubScribeScrips?.push(obj);
                    delete objpreviosScripsCopy[key];
                }
            });
            sendTouchlineRequest(unSubScribeScrips);
            sendTouchlineRequest(subscribeScrips);
            useDebounce(() => {
                const lastTickData = dispatch(getWfhTouchlineLastTick());
                arrVisibleRows?.forEach((eachScrip) => {
                    let selectedScrip = lastTickData[`${eachScrip?.exchangeId + '_' + eachScrip?.token}`];
                    if (selectedScrip?.length > 0) {
                        handleSipGrid(selectedScrip);
                    }
                });

            }, 1000);
            return { ...objpreviosScripsCopy };
        });
    }, [dispatch, handleSipGrid]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    useEffect(() => {
        //here we send request for only visible scrips
        if (arrSipOrdersGridRowData?.length > 0) {
            setTimeout(() => {
                handleVisibleRows();
            }, 1000);
        }
    }, [arrSipOrdersGridRowData, ordersTabKey, handleVisibleRows]);
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End


    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --Start
    const handleScrollEnd = async (e) => {
        if (e.direction === 'vertical') {
            handleVisibleRows();
        }
    };
    //Ameersha N -- 28-08-2024 -- Subscription for visible scrips functionality --End

    const onRowGroupOpened = async (event) => {
        const rowNode = event.node;
        const rowData = rowNode.data;
        // if (rowNode.expanded && rowData?.id) {
        //     dispatch(getSipOrderHistory({ id: rowData?.id }, ordersTabKey));
        // } else { }
    };
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
    const getEvent = useAnalyticsEventTracker('ORDERBOOK');


    useEffect(() => {

        switch (ordersTabKey) {
            case ORDERS_TABKEY.ALL_ORDERS:
                getEvent('EQUITY_SIP_ALL_ORDERS');
                setArrSipOrdersGridRowData(arrAllSipOrders);
                break;
            case ORDERS_TABKEY.OPEN_ORDERS:
                getEvent('EQUITY_SIP_OPEN_ORDERS');
                setArrSipOrdersGridRowData(arrOpenSipOrders);
                break;
            case ORDERS_TABKEY.COMPLETED_ORDERS:
                getEvent('EQUITY_SIP_COMPLETED_ORDERS');
                setArrSipOrdersGridRowData(arrCompletedSipOrders);
                break;
            default:
                break;
        }
    }, [ordersTabKey, arrAllSipOrders, arrOpenSipOrders, arrCompletedSipOrders]);
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    const handleApiCall = () => {
        switch (ordersTabKey) {
            case ORDERS_TABKEY.ALL_ORDERS:
                dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }, isHistoryAllowed));
                dispatch(setCurrentPage(1));
                ORDERS_GRID_REF.current?.api?.ensureIndexVisible(0, 'top');
                break;
            case ORDERS_TABKEY.OPEN_ORDERS:
                dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }, isHistoryAllowed));
                dispatch(setCurrentPage(1));
                ORDERS_GRID_REF.current?.api?.ensureIndexVisible(0, 'top');

                break;
            case ORDERS_TABKEY.COMPLETED_ORDERS:

                dispatch(getAllSipOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }, isHistoryAllowed));
                dispatch(setCurrentPage(1));
                ORDERS_GRID_REF.current?.api?.ensureIndexVisible(0, 'top');

                break;

            default:
                break;
        }
    };

    useEffect(() => {
        handleApiCall();
    }, [dispatch, ordersTabKey]);
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End





    useWFHMessages('touchline', (e) => {
        handleSipGrid([...e.detail]);
    });
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End


    const orders = useMemo(() => {
        const openSipOrders = getSipOrder?.filter((each) => each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_ACTIVE || each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_OMSXMITTED);
        const CompletedSipOrders = getSipOrder?.filter((each) => each?.status === ALL_ORDERS_STATUS.ORDER_STATUS_COMPLETED);
        return { openSipOrders, CompletedSipOrders };
    }, [getSipOrder]);

    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start

    let strSearch = null;

    const onChangeGridHeaderSearch = useCallback((e) => {
        strSearch = e?.target?.value;
        searchedText.current = strSearch;
        ORDERS_GRID_REF?.current?.api?.onFilterChanged();
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- Start
        displayZeroStateForGrid(ORDERS_GRID_REF);
        // Vinit R - 04-07-2024 -- Add zero state for AG grid -- End
    }, []);

    const isExternalFilterPresent = useCallback(() => {
        return strSearch !== null;
    }, []);

    const doesExternalFilterPass = useCallback(
        (node) => {
            if (!strSearch) {
                return true;
            } else {
                const keywords = strSearch?.toString()?.toLowerCase()?.split(' ');
                let strRowData = node?.data?.symbol + node?.data?.exchange;
                return keywords?.every(keyword => strRowData?.toLowerCase()?.includes(keyword));
            }
        },
        [strSearch]
    );
    const filterChangeHandler = () => {
        const isFilterApplied = Object.keys(ORDERS_GRID_REF?.current?.api?.getFilterModel())?.length > 0 || searchedText?.current?.length > 0;
        if (isFilterApplied) {
            const filteredData = [];
            ORDERS_GRID_REF?.current?.api?.forEachNodeAfterFilter(node => {
                filteredData.push(node.data);
            });
            setFilteredData(filteredData);
        } else {
            setFilteredData([]);
        }
    };
    useEffect(() => {
        ORDERS_GRID_REF?.current?.api?.eventService?.addEventListener('filterChanged', filterChangeHandler);
        return () => ORDERS_GRID_REF?.current?.api?.eventService?.removeEventListener('filterChanged', filterChangeHandler);
    }, []);
    const filterOptions = [
        'equals',
        'notEqual',
        'lessThan',
        'lessThanOrEqual',
        'greaterThan',
        'greaterThanOrEqual',
        'inRange',
        'blank',
        'notBlank'
    ];

    const getFilterDataForGrid = ({ filterOption, value, filterText }) => {
        if (filterText == null) {
            return false;
        } else {
            switch (filterOption) {
                case 'equals': {
                    return parseFloat(filterText) === parseFloat(value);
                }
                case 'notEqual': {
                    return parseFloat(filterText) !== parseFloat(value);
                }
                case 'lessThan': {
                    return parseFloat(value) < parseFloat(filterText);
                }
                case 'lessThanOrEqual': {
                    return parseFloat(value) <= parseFloat(filterText);
                }
                case 'greaterThan': {
                    return parseFloat(value) > parseFloat(filterText);
                }
                case 'greaterThanOrEqual': {
                    return parseFloat(value) >= parseFloat(filterText);
                }
                case 'inRange': {
                    const agFilterModel = ORDERS_GRID_REF?.current?.api?.getFilterModel();
                    if (Object?.keys(agFilterModel)?.length > 0) {
                        const fromValue = agFilterModel[Object?.keys(agFilterModel)[0]].filter;
                        const toValue = agFilterModel[Object?.keys(agFilterModel)[0]].filterTo;
                        return parseFloat(value) >= parseFloat(fromValue) && parseFloat(value) <= parseFloat(toValue);
                    } else {
                        return false;
                    }
                }
                case 'blank': {
                    return false;
                }
                case 'notBlank': {
                    return true;
                }
                default:
                    return false;
            }
        }
    };

    const RowData = ({ value, data, ...props }) => { return value; };


    const arrSipEquityColumns = useMemo(() => {
        const arrOrderColumnDefs = SIPTenantColumnProfiles?.map((item) => {
            switch (item.field) {
                case 'time':
                    item = {
                        ...item,
                        filter: 'agDateColumnFilter', filterParams: {
                            comparator: gridDateFilter
                        },
                        cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;

                case "symbol":
                    item = {
                        ...item, pinned: 'left', lockPosition: "left", suppressMovable: true,
                        suppressNavigable: true, headerComponent: GridHeaderSearch, headerComponentParams: { onChangeGridHeaderSearch, gridRef: ORDERS_GRID_REF }, cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            {/* Azeem K : 07-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
                            <div >
                                <div className='d-flex align-items-center'>
                                    <span className='font-medium font-enlarge color-text ms-3 text-uppercase'>{data?.symbol}</span> {/* Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings */}
                                    <span className='chips-wrap px-2'>
                                        <BzChip className='exchange-chip text-capitalize'>{data?.exchange}</BzChip>
                                    </span>
                                    {/*    DontMiss Logic commented as BA (Mithun) suggested dontMiss will not show for orders */}
                                    {/* {data?.dontMiss?.length > 0 && <span className='icon-16 icon-dontmiss icon-yellow ms-2'></span>} */}
                                    {holdingsScrips?.length > 0 && holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === data?.segment_id + '_' + data?.scrip_token) ? < span className='icon-16 icon-portfolio icon-dark ms-2'></span> : null}
                                </div >
                            </div >
                            {/* Azeem K : 07-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}
                        </SipGridPopover>
                    };
                    return item;
                case 'id': item = {
                    ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                        <RowData value={value} data={data} props={props} />
                    </SipGridPopover>
                };
                    return item;
                case 'transaction_type':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellClassRules: {
                            ' color-positive': params => params?.data.transaction_type === 'BUY',
                            ' color-negative': params => params?.data.transaction_type === 'SELL',
                        },
                        hide: ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS || ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS,
                        cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'invested_qty_or_val':
                    item = {
                        ...item, filter: 'agNumberColumnFilter', valueFormatter: params => Math.floor(params?.value), cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'cap_price':
                    item = {
                        ...item, filter: 'agTextColumnFilter', valueFormatter: params => Math.floor(params?.value), filterParams: {
                            textMatcher: getFilterDataForGrid,
                            filterOptions: filterOptions
                        }, cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- Start
                case 'status':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <StatusChip isSipStatusChip={true} data={data} value={value} bisEnlargementClass={true} props={props} />
                        </SipGridPopover>,
                        valueGetter: (params) => _getSIPOrderDisplayStatus(params?.data?.status)
                    };
                    return item;
                // Vinit Raut : 25-01-2024 : BT-107418 - Breeze – SIP Order book -- End
                case 'ltp':
                    item = {
                        ...item, filter: 'agTextColumnFilter', valueFormatter: params => Math.floor(params?.value)?.toFixed(2), filterParams: {
                            textMatcher: getFilterDataForGrid,
                            cellClassRules: {
                                'watchlist-ag-grid-positive-cell': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'U',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'watchlist-ag-grid-negative-cell': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'D',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                                'watchlist-ag-grid-transparent-cell': params => params?.data[WATCHLIST_GRID_INDEX.NET_CHANGE_INDICATOR] === 'S',   //Bhagyashri P [17-11-2023] : BT-110050 Setting Preferences classes
                            },
                            filterOptions: filterOptions
                        }, cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'executed_and_numberof_installment':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover placement='left' data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'frequency_details':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover placement='left' data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'investment_type':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'frequency_type':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'created_date':
                    item = {
                        ...item, filter: 'agDateColumnFilter', filterParams: {
                            comparator: gridDateFilter
                        }, cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'frequency_start_date':
                    item = {
                        ...item, filter: 'agDateColumnFilter', filterParams: {
                            comparator: gridDateFilter
                        }, cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'installment_date':
                    item = {
                        ...item, filter: 'agDateColumnFilter', filterParams: {
                            comparator: gridDateFilter
                        }, cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'investment_value':
                    item = {
                        ...item, filter: 'agNumberColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'created_by':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'modified_by':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;
                case 'price':
                    item = {
                        ...item, filter: 'agTextColumnFilter', cellRenderer: ({ data, value, ...props }) => <SipGridPopover data={data} {...props}>
                            <RowData value={value} props={props} />
                        </SipGridPopover>
                    };
                    return item;

                default:
                    return item;
            }
        });
        const objChecboxColumn = [{
            colId: "check",
            hide: true,
            headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true,
            pinned: 'left',
            width: '40'
        }, {
            headerName: "", field: "expandCell",
            cellRenderer: 'agGroupCellRenderer',
            pinned: 'left',
            width: '50',
            maxWidth: 50,
            detailCellRendererParams: { placement: 'right' },
            pinned: 'left',
            suppressMovable: true,
            lockPosition: "left",
            suppressNavigable: true,
            menuTabs: [],
            cellStyle: { display: "flex", alignItems: "center", justifyContent: "center" }
        }];
        return [...objChecboxColumn, ...arrOrderColumnDefs];

    }, [SIPTenantColumnProfiles]);
    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

    const selectionColumnDef = useMemo(() => {
        return {
            pinned: 'left',
            hide: true,
        };
    }, []);
    const bIsMultipleOrdersCancelinProcess = useSelector(state => state.orders?.bIsMultipleOrdersCancelinProcess);


    const rowSelection = useMemo(() => {
        return {
            mode: isButtonDisabled || bIsMultipleOrdersCancelinProcess ? GRID_ROW_SELECTION_TYPE.MULTI_ROW : GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
            isRowSelectable: (params) => isRowSelectable(params),
            checkboxes: true
        };
    }, [bIsMultipleOrdersCancelinProcess, isButtonDisabled, isRowSelectable]);
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
    // logic for dynamic api call on scroll dow start
    const [nGridHeight, setNGridHeight] = useState(0);
    const rowNode = useMemo(() => {

        return ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
    }, []);
    const nRowHeight = rowNode?.rowHeight;

    useEffect(() => {
        if (arrSipOrdersGridRowData?.length > 0) {
            setNGridHeight(+arrSipOrdersGridRowData?.length * nRowHeight);
        }
    }, [arrSipOrdersGridRowData, ordersTabKey, nRowHeight, ORDERS_GRID_REF?.current]);

    // Vinit R : 26-07-2024 Open market overview modal -- Start
    const handleOverview = async (e) => {
        e.preventDefault(); // Prevent the default browser behavior for F5 key press
        if (!isGuestUser()) {
            if (ORDERS_GRID_REF?.current?.api.getSelectedRows().length > 0) {
                const data = ORDERS_GRID_REF?.current?.api.getSelectedRows()[0];
                const scripDataRes = await _getScripsInfo([{ mkt: data?.exchangeSegment, token: data?.scrip_token }]);
                const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
                const scripData = convertScripResponseWatchlistGrid(scripDataObj);
                sendBestFiveRequest({ exchangeId: scripData?.[0]?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], token: scripData?.[0]?.[WATCHLIST_GRID_INDEX.TOKEN], isSubscribe: true });
                dispatch(setScripOverviewData(scripData?.[0]));
                dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }]));
            }
            else { }
        }
        else {
            dispatch(handleModal([{ "GUEST_USER_RESTRICTION_MODAL": true }]));
        }

    };

    useSingleKey('f5', handleOverview);
    // Vinit R : 26-07-2024 Open market overview modal -- End

    const handleApiCallOnScroll = (offSet) => {

        let nMaxLimit = 0;
        if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
            nMaxLimit = objEquitySIPMetaData?.total_records;
        } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
            nMaxLimit = objEquitySIPMetaData?.open_records;
        } else if (ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS) {
            nMaxLimit = objEquitySIPMetaData?.completed_records;
        }
        if (arrSipOrdersGridRowData?.length < nMaxLimit && offSet > nCurrentPage) {
            dispatch(setCurrentPage(offSet));

            dispatch(getAllSipOrders({ offSet: offSet, limit: ORDERS_LIMIT_IN_API, orderStatus: ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ? ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS : ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS ? ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS : ORDERBOOK_API_ORDER_STATUS.COMPLETED_ORDERS }, isHistoryAllowed)).then((objresp) => {
                bIsApiFiring = false;
            }
            ).catch((error) => {
                bIsApiFiring = false;
                console.log(error);
            });

        } else {
            bIsApiFiring = false;

        }

    };

    const detailCellRendererParams = useMemo(() => {
        return {
            detailGridOptions: {
                rowSelection: 'multiple',
                suppressRowClickSelection: true,
                enableRangeSelection: false,
                pagination: false,
                paginationAutoPageSize: false,
                columnDefs: [
                    { field: 'transaction_date', headerName: "Trade Date", valueFormatter: params => moment(params.value).format("DD MMM 'YY") },
                    { field: 'traded_quantity', headerName: 'Trade Qty', minWidth: 150 },
                    { field: 'traded_price', headerName: "Trade Price" },
                    { field: 'remarks', headerName: "REMARKS." },
                ],
                defaultColDef: {
                    flex: 1,
                    suppressMovable: true,
                    lockPosition: 'left',
                    suppressNavigable: true,
                    // Azeem K :04-09-2025 : hide kebab menu from detailCellrender Grid - Start
                    suppressMenu: true,
                    suppressHeaderMenuButton: true,
                    sortable: false,
                    // Azeem K :04-09-2025 : hide kebab menu from detailCellrender Grid - End
                },
            },
            getDetailRowData: (params) => {
                let temp = params?.data?.orderHistory;//[]
                // params.data.additionalData.forEach(data => {temp.push(data.expiry_date === )})
                params.successCallback(temp);
            },
        };
    }, []);

    const handleScroll = () => {
        const gridApi = ORDERS_GRID_REF.current.api;
        const scrollPosition = gridApi?.getVerticalPixelRange()?.bottom;
        const rowNode = ORDERS_GRID_REF?.current && ORDERS_GRID_REF?.current?.api?.getDisplayedRowAtIndex(0);
        const nRowHeight = rowNode?.rowHeight;
        const gridHeight = arrSipOrdersGridRowData?.length * nRowHeight;
        setNGridHeight(gridHeight);

        if (gridHeight - scrollPosition <= nRowHeight * 5 && !bIsApiFiring) { //nRowHeight * 5===> call api when 5 row remaining on scroll
            bIsApiFiring = true;
            handleApiCallOnScroll(nCurrentPage + 1);
            bIsApiFiring = true;
        }

    };
    // logic for dynamic api call on scroll dow End
    // Azeem K : 20-12-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End

    // Hari k:22-03-2024: BT-108447: create watchlist from list- start
    // const handleCreateWatchlist = () => {
    //     const arrScrips = arrAllSipOrders?.map((eachScrip) => {
    //         return { nMarketSegmentId: eachScrip?.segment_id.split("_")[0], nToken: eachScrip?.scrip_token };
    //     });
    //     createNewWatchlist(objLoginSession, arrScrips, "dynamic", TenantId, 'My Orders', dispatch);
    // };
    // Hari k:22-03-2024: BT- 108447:create watchlist from list- end


    const bIsOrderApiPending = useSelector(state => state?.orders?.bIsOrderApiPending);
    const handlePlaceOrder = () => {
        dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.EQUITY_SIP } }));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: [] };
        dispatch(getScripOrderInfo(objScrpinfo));
    };

    const handleSipScripsUnSubscription = useCallback(() => {
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'sip orderbook');
    }, [objScripsRequest]);

    useUnload(() => {
        handleSipScripsUnSubscription();
    });

    const onGridPreDestroyed = useCallback((params) => {
        // this function gets called when the grdi before gets destroyed means getting removed from dom
        handleScripUnsubScriptionOnUnMount(objScripsRequest, 'sip orderbook');
    }, [objScripsRequest]);



    useUnload(() => {
        handleSipScripsUnSubscription();
    });


    return (
        <>
            <Container fluid className='p-0'>
                <Row className='g-0 pt-1 px-3'>
                    <Col md={8}>
                        <BzTabs className='nav nav-tabs'>
                            {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start */}
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('all_orders')} isActive={ordersTabKey === ORDERS_TABKEY.ALL_ORDERS} tabKey='all_orders'>All Orders ({objEquitySIPMetaData?.total_records || 0})</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('open_orders')} isActive={ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS} tabKey='open_orders'>Open Orders ({objEquitySIPMetaData?.open_records || 0})</BzTab>
                            <BzTab className='nav-link text-capitalize' onClick={() => onTabChange('completed_orders')} isActive={ordersTabKey === ORDERS_TABKEY.COMPLETED_ORDERS} tabKey='completed_orders'>Completed Orders ({objEquitySIPMetaData?.completed_records || 0})</BzTab>
                        </BzTabs>
                    </Col>
                    <Col md={4}>
                        <div className='d-flex justify-content-end align-items-center pt-1'>
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- start*/}
                            {/* {ordersTabKey === ORDERS_TABKEY.ALL_ORDERS ?
                                <div className='d-flex align-items-center cursor-pointer' disabled={isButtonDisabled}>
                                    <BzButton className='btn btn-sm btn-outline d-flex align-items-center ms-3' onClick={handleCreateWatchlist}>
                                        <div class="icon-12 icon-add icon-primary me-2"></div>
                                        <span className='font-medium'>Watchlist</span>
                                    </BzButton>
                                </div> : null} */}
                            {/* Hari k:22-03-2024: BT-108447: create watchlist from list- end*/}
                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --Start */}
                            <div className='d-flex align-items-center cursor-pointer focus p-1 me-3 gap-2' onClick={handleApiCall}>
                                <div className='icon-16 icon-refresh background-textual-link-withicon d-flex flex-shrink-0'></div>
                                <div className='font-medium font-size3 color-textual-link-withicon p-t-2'>Refresh</div>
                            </div>
                            {/* Azeem K :27-04-2024:BT-102298: Added refresh functionality in orders screen --End */}
                            {/* Vaibhav SIngh: BT-102298: 09-02-24:Cancel All Order Buton FIxed:Start */}
                            {ordersTabKey !== ORDERS_TABKEY.COMPLETED_ORDERS ?
                                <BzButton className='btn btn-outline btn-sm text-capitalize ms-3' onClick={onCancelOrder} disabled={isButtonDisabled || objEquitySIPMetaData?.open_records < 1}>Cancel All Order</BzButton> : null}
                            {/* Vaibhav SIngh: BT-102298: 09-02-24:Cancel All Order Buton FIxed:End */}
                        </div>
                        {/* Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End */}
                    </Col>
                </Row>

            </Container>
            <LoginLoader spinner={bIsOrderApiPending} spinnerContent="Fetching Details" />
            {arrSipOrdersGridRowData?.length > 0 ?
                <div className='mt-2'>
                    <BzMasterAgGrid
                        gridProfileType={MANAGE_COLUMNS_VIEW_TYPES.ORDER_EQUITY_SIP_VIEW_TYPE}
                        onGridPreDestroyed={onGridPreDestroyed}
                        arrRowData={filteredData?.length > 0 ? filteredData : arrSipOrdersGridRowData}
                        selectionColumnDef={selectionColumnDef}
                        ref={ORDERS_GRID_REF}
                        onBodyScrollEnd={handleScrollEnd}
                        rowBuffer={1}
                        isMasterDetail={isMasterDetail}
                        isSuppressMenu={false}
                        // gridDetailCellRenderer={gridDetailCellRenderer}
                        gridDetailCellRendererParams={detailCellRendererParams}
                        rowHeight={36} detailRowAutoHeight={true} className='ag-theme-alpine orders-ag-grid-wrapper'
                        getRowId={getRowId} onRowSelected={onRowSelected} rowSelection={rowSelection}
                        rowClass='font-enlarge' //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                        // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start
                        arrColumnData={arrSipEquityColumns} isExternalFilterPresent={isExternalFilterPresent} doesExternalFilterPass={doesExternalFilterPass} isRowSelectable={isRowSelectable} onRowGroupOpened={onRowGroupOpened} onBodyScroll={handleScroll}
                    // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End
                    />
                </div> : !bIsOrderApiPending && arrSipOrdersGridRowData?.length <= 0 ?
                    <div className='zero-state-alerts zero-state-alerts-xxl'>
                        <ZeroStates handleOnClick={handlePlaceOrder} heading="No orders available" icon='icon-64 icon-nodata mb-3 mrgauto' btnText="Place an order today" btnClass="btn btn-md btn-outline mt-2" />
                    </div> : null


            }

        </>
    );
};


export default memo(Sip);